<template>
  <div>
    <h1>Erreur 404 🥴</h1>
    <h3>Cette page n'existe pas !</h3>
  </div>
</template>

<style scoped>
div {
  margin: auto auto;
}

h1, h3 {
  text-align: center;
}

h1 {
  font-weight: 300;
  font-size: 4rem;
}

h3 {
  font-weight: 300;
}
</style>